import React from 'react';
import styled from 'styled-components/native';
import SkeletonPlaceholder from '../skeletonPlaceholder';
import {StyleProp, View, ViewStyle} from 'react-native';
import useResponsiveDimensions from '../../utils/hooks/useResponsiveDimensions';

const Container = styled.View`
  width: 100%;
`;

const PaddingView = styled.View<{isMobile: boolean; width: number}>`
  width: 100%;
  max-width: ${({isMobile}) => (isMobile ? '100%' : '1000px')};
  padding-horizontal: ${({isMobile, width}) =>
    isMobile ? '3%' : width < 1100 ? '2%' : '8%'};
  align-self: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${({isMobile, width}) => isMobile ? '2%' : width < 1100 ? '3%' : '2%'};
`;

const HomeTabsSkeleton = ({style}: {style?: StyleProp<ViewStyle>}) => {
  const {width, isMobile, getResponsiveSize, getByScreenSize} = useResponsiveDimensions();

  // Show 6 skeleton items matching the actual tabs (3 tabs duplicated)
  const skeletonItems = [0, 1, 2, 3, 4, 5];

  // Match the same width calculation as home tabs
  const getTabWidth = () => {
    // Since we're showing 6 skeleton items (representing 3 tabs duplicated),
    // we use 2-column layout for 3 or fewer actual tabs
    const tabCount = 3; // This represents the 3 actual tabs before duplication
    
    if (tabCount <= 3) {
      // 3 or fewer tabs: use wider items to fill container better
      // Mobile: 48% (2 columns), Tablet/Desktop: 31.33% (3 columns filling ~96% with gaps)
      return isMobile ? '48%' : '31.33%';
    }
    // More than 3 tabs: use responsive 3-column sizing
    // Mobile: 40%, Tablet: 30%, Desktop: 30%
    return getResponsiveSize(40, 30, 30) + '%';
  };

  return (
    <Container style={style} pointerEvents={'none'}>
      <PaddingView isMobile={isMobile} width={width}>
        {skeletonItems.map(item => (
          <View
            key={item}
            style={{
              width: getTabWidth(),
              aspectRatio: 1,
              borderRadius: 30,
              marginBottom: '2%',
            }}>
            <SkeletonPlaceholder
              width={'100%'}
              aspectRatio={1}
              marginBottom={0}
              borderRadius={30}
            />
          </View>
        ))}
      </PaddingView>
    </Container>
  );
};

export default HomeTabsSkeleton;
